import type { IconData } from "../iconData.types";

const iconData: IconData = {
  viewBox: "0 0 24 24",
  paths: (
      <path d="M19.6596 3H4.34043C3.98492 3 3.64398 3.14122 3.3926 3.3926C3.14122 3.64398 3 3.98492 3 4.34043V19.6596C3 20.0151 3.14122 20.356 3.3926 20.6074C3.64398 20.8588 3.98492 21 4.34043 21H19.6596C20.0151 21 20.356 20.8588 20.6074 20.6074C20.8588 20.356 21 20.0151 21 19.6596V4.34043C21 3.98492 20.8588 3.64398 20.6074 3.3926C20.356 3.14122 20.0151 3 19.6596 3ZM19.8511 4.34043V19.0392L4.96181 4.14894H19.6596C19.7104 4.14894 19.7591 4.16911 19.795 4.20502C19.8309 4.24093 19.8511 4.28964 19.8511 4.34043ZM4.14894 19.6596V4.96085L19.0382 19.8511H4.34043C4.28964 19.8511 4.24093 19.8309 4.20502 19.795C4.16911 19.7591 4.14894 19.7104 4.14894 19.6596Z" />
    ),
};

export default iconData;
